export const routes = {
    //app
    home: "/",
    //auth
    login: "/login",
    register: "/register",
    //reservation / fastcheckin
    reservation: "/reservation",
    fastcheckin: "/fastcheckin",
    //confirmation
    confirmation: "/confirmation",
    //customer area user
    customerArea: "/user",
    customerArea_reservations: "/user/reservations",
    customerArea_info: "/user/infos",
    customerArea_booklets: "/user/booklets",
    customerArea_fidelity: "/user/fidelity",
    customerArea_notifications: "/user/notifications",
    //customer area partner
    partnerArea: "/partner",
    partnerArea_accommodations: "/partner/accommodations",
    partnerArea_info: "/partner/infos",
    partnerArea_bills: "/partner/bills",
    partnerArea_bankAccounts: "/partner/bankAccounts",
    partnerArea_notifications: "/partner/notifications",
    //customer area owner
    ownerArea: "/owner",
    ownerArea_reservations: "/owner/reservations",
    ownerArea_info: "/owner/infos",
    ownerArea_bills: "/owner/bills",
    ownerArea_bankAccounts: "/owner/bankAccounts",
    ownerArea_leases: "/owner/leases",
    ownerArea_occupationRights: "/owner/occupationRights",
    ownerArea_notifications: "/owner/notifications",
}